import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Herpes Stigma Index",
  tags: ["root"],
  conditions: {
    postTypes: ["page"],
  },
}

export default defineBlock("stigma-index/stigma-index", (props) => {
  return (
    <InnerBlocks
      template={[
        ["content/subpage-hero", null],
        ["leaderboard", null],
        ["home/stats", null],
      ]}
      templateLock="all"
      orientation="vertical"
    />
  )
})
